import rowNotes from "./rowNotes"
import columnNotes from "./columnNotes"

export default [
  { text: "Row notes", value: rowNotes },
  { text: "Column notes", value: columnNotes }
]
